"use client";
import { useTranslations } from "next-intl";
import { useClientValue } from "@/lib/useClientValue";
import { isEvalRunning, subscribePendingEval } from "@/lib/pendingEval";

// Sağ üstte, rapor yazıldığı sürece dönen daire. "Hazırlanıyor" toast'ı birkaç
// saniyede kapanıyor ve ardından ekranda raporun yolda olduğuna dair iz
// kalmıyordu (sahibinin notu). Yoklamayı `PendingEvalWatcher` yapar; bu bileşen
// yalnızca kaydı okur: hazır olunca (`ready`) ya da kayıt silinince kaybolur.
export function ReportPendingIndicator() {
  const t = useTranslations("reportToast");
  const running = useClientValue(isEvalRunning, false, subscribePendingEval);
  if (!running) return null;
  const label = t("runningTitle");
  return (
    <span
      role="status"
      aria-label={label}
      title={label}
      className="inline-flex items-center gap-2 rounded-full px-2.5 py-1.5 text-xs font-medium"
      style={{ background: "var(--accent-light)", color: "var(--accent)" }}
    >
      <span
        aria-hidden
        className="h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current"
        style={{ borderTopColor: "transparent" }}
      />
      <span className="hidden md:inline whitespace-nowrap">{label}</span>
    </span>
  );
}
